import React from "react";
import { Img } from "../Img";
export const ContactItemContent = ({ title, imgUrl, imgAlt, }) => (React.createElement(React.Fragment, null,
    React.createElement(Img, { src: imgUrl, alt: imgAlt }),
    React.createElement("p", { className: "caption2-bold" }, title)));
